export const DEFAULT_PAGINATION_RECORDS_ARRAY = [10, 50, 100];
export const DEFAULT_PAGINATION_RECORDS_COUNT = 10;
export const DEFAULT_PAGINATION_ACTIVE_PAGE = 1;
export const ANALYST_MINIMART_LOANS_PAGINATION_RECORDS_ARRAY = [4];
